import { Link, useSearchParams } from "react-router-dom";
import { Lockup } from "../components/Logo.js";

/**
 * Artboard 1b. Two providers at equal weight, Microsoft first, and the fixed
 * copy: "Continue with Microsoft Entra ID" and "work or school account".
 * There is deliberately no personal Microsoft account option and no password.
 */

const ERRORS: Record<string, { title: string; detail: string }> = {
  personal_account: {
    title: "That's a personal Microsoft account",
    detail:
      "Meet With works with work or school accounts. Sign in with the account your organization gave you, or use Google instead.",
  },
  state: {
    title: "That sign-in attempt expired",
    detail: "Sign-in links are valid for a few minutes. Please start again.",
  },
  denied: {
    title: "Sign-in was cancelled",
    detail: "Nothing happened. You can try again whenever you like.",
  },
  exchange: {
    title: "We couldn't finish signing you in",
    detail: "Something went wrong between here and your provider. Please try again.",
  },
};

export function SignIn() {
  const [params] = useSearchParams();
  const code = params.get("error");
  const error = code ? ERRORS[code] : undefined;

  return (
    <main className="centered">
      <section className="card" aria-labelledby="signin-heading">
        <Lockup size={22} />
        <h1 id="signin-heading">Sign in or create an account</h1>
        <p className="lede">One account for all your connected calendars.</p>

        {error ? (
          <div className="notice notice-error" role="alert">
            <strong>{error.title}</strong>
            <span>{error.detail}</span>
          </div>
        ) : null}

        <a className="provider" href="/auth/microsoft">
          <span className="monogram" aria-hidden="true">
            M365
          </span>
          Continue with Microsoft Entra ID
        </a>

        <a className="provider" href="/auth/google">
          <span className="monogram" aria-hidden="true">
            G
          </span>
          Continue with Google
        </a>

        <p className="helper">
          Microsoft sign-in uses your <strong>work or school account</strong>. You can add
          calendars from other organizations after signing in.
        </p>

        <p className="footnote">
          Signing in creates an owner account if you don't have one. Invited visitors
          don't sign in here — use the link in your email.
        </p>

        <p className="footnote">
          <Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link> — worth a
          look before you hand over calendar access.
        </p>
      </section>
    </main>
  );
}
